import React from "react";
import "./index.scss";
import $ from "jquery";
import { LoadPanel } from "devextreme-react/load-panel";

const MdaeLoader = ({ show = false, isDisableFocusState = false }) =>
  !show ? null : (
    <LoadPanel
      visible={show}
      width={270}
      height={90}
      focusStateEnabled={!isDisableFocusState}
      shading={true}
      shadingColor={"rgba(0,0,0,0.4)"}
      showIndicator={true}
      showPane={true}
      hideOnOutsideClick={false}
      onShown={(e) => {
        $(e.component.content())
          .parent()
          .css("z-index", 1800);
      }}
      className="sys-mdae-loader"
    />
  );

export default MdaeLoader;
